import { render, staticRenderFns } from "./WarningContent.vue?vue&type=template&id=e3b6c9d8&scoped=true"
import script from "./WarningContent.vue?vue&type=script&lang=js"
export * from "./WarningContent.vue?vue&type=script&lang=js"
import style0 from "./WarningContent.vue?vue&type=style&index=0&id=e3b6c9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b6c9d8",
  null
  
)

export default component.exports